import { render, staticRenderFns } from "./panel_pets.vue?vue&type=template&id=2d49f281&scoped=true&"
import script from "./panel_pets.vue?vue&type=script&lang=js&"
export * from "./panel_pets.vue?vue&type=script&lang=js&"
import style0 from "./panel_pets.vue?vue&type=style&index=0&id=2d49f281&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d49f281",
  null
  
)

export default component.exports